<app-page-shell>
    <p-toast position="top-center"></p-toast>

    <app-page-detail-hero eyebrow="Payment Proposal" [title]="proposal?.proposalNumber || 'Proposal'" subtitle="Approval, release, voucher, and remittance control center." icon="pi pi-money-bill">
        <div tags>
            <p-tag [value]="proposal?.status || 'DRAFT'" [severity]="severity(proposal?.status)"></p-tag>
            <p-tag [value]="money(proposal?.totalProposedPayment)" severity="success"></p-tag>
        </div>
        <div actions>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (click)="back()"></p-button>
            <p-button label="Approve" icon="pi pi-check" severity="success" [outlined]="true" (click)="approve()" *ngIf="proposal?.status === 'DRAFT'"></p-button>
            <p-button label="Release" icon="pi pi-send" severity="warn" [outlined]="true" (click)="release()" *ngIf="proposal?.status === 'APPROVED'"></p-button>
            <p-button label="Generate Vouchers" icon="pi pi-wallet" severity="help" [outlined]="true" (click)="vouchers()" *ngIf="proposal?.status === 'APPROVED' || proposal?.status === 'RELEASED'"></p-button>
            <p-button label="Remittance" icon="pi pi-envelope" severity="secondary" [outlined]="true" (click)="remittance()" *ngIf="proposal?.status === 'VOUCHERS_GENERATED'"></p-button>
        </div>
    </app-page-detail-hero>

    <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)" *ngIf="proposal">
        <p-tablist>
            <p-tab value="overview"><app-accounting-tab-label icon="pi pi-info-circle" label="Overview"></app-accounting-tab-label></p-tab>
            <p-tab value="lines"><app-accounting-tab-label icon="pi pi-list" label="Lines"></app-accounting-tab-label></p-tab>
            <p-tab value="excluded"><app-accounting-tab-label icon="pi pi-ban" label="Excluded"></app-accounting-tab-label></p-tab>
            <p-tab value="payment"><app-accounting-tab-label icon="pi pi-credit-card" label="Payment"></app-accounting-tab-label></p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="overview">
                <app-page-data-panel title="Proposal Summary" subtitle="Unallocated vendor credits do not reduce proposed payments; review them before paying.">
                    <div class="detail-grid">
                        <div><strong>Run date</strong><span>{{ proposal.runDate | date:'yyyy-MM-dd' }}</span></div>
                        <div><strong>Due cutoff</strong><span>{{ proposal.dueDateCutoff | date:'yyyy-MM-dd' }}</span></div>
                        <div><strong>Payable</strong><span>{{ money(proposal.totalPayableAmount) }}</span></div>
                        <div><strong>Credit applied</strong><span>{{ money(proposal.totalCreditApplied) }}</span></div>
                        <div><strong>Cash payment</strong><span>{{ money(proposal.totalProposedPayment) }}</span></div>
                        <div><strong>Release reference</strong><span>{{ proposal.releaseReference || '-' }}</span></div>
                    </div>
                </app-page-data-panel>
            </p-tabpanel>
            <p-tabpanel value="lines">
                <app-page-data-panel title="Ready Lines" [resultText]="readyLines.length + ' payable lines'">
                    <ng-container *ngTemplateOutlet="linesTable; context: { $implicit: readyLines }"></ng-container>
                </app-page-data-panel>
            </p-tabpanel>
            <p-tabpanel value="excluded">
                <app-page-data-panel title="Excluded Lines" subtitle="Rows excluded by hold, approval, match, open amount, or bank verification controls." [resultText]="excludedLines.length + ' excluded'">
                    <ng-container *ngTemplateOutlet="linesTable; context: { $implicit: excludedLines }"></ng-container>
                </app-page-data-panel>
            </p-tabpanel>
            <p-tabpanel value="payment">
                <app-page-data-panel title="Voucher and Remittance Links">
                    <ng-container *ngTemplateOutlet="linesTable; context: { $implicit: proposal.lines || [] }"></ng-container>
                </app-page-data-panel>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>

    <ng-template #linesTable let-lines>
        <p-table [value]="lines" [loading]="loading" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Bill</th>
                    <th>Vendor</th>
                    <th>Status</th>
                    <th>Due</th>
                    <th class="numeric">Payable</th>
                    <th class="numeric">Credit</th>
                    <th class="numeric">Payment</th>
                    <th>Voucher</th>
                    <th>Remittance</th>
                    <th>Reason</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-line>
                <tr>
                    <td>{{ line.billNumber || line.billId }}</td>
                    <td>{{ line.vendorName || line.vendorId || '-' }}</td>
                    <td><p-tag [value]="line.readinessStatus || 'READY'" [severity]="severity(line.readinessStatus)"></p-tag></td>
                    <td>{{ line.dueDate | date:'yyyy-MM-dd' }}</td>
                    <td class="numeric">{{ money(line.payableAmount, line.currencyCode || proposal?.currencyCode || 'SAR') }}</td>
                    <td class="numeric">{{ money(line.creditApplied, line.currencyCode || proposal?.currencyCode || 'SAR') }}</td>
                    <td class="numeric">{{ money(line.proposedPayment, line.currencyCode || proposal?.currencyCode || 'SAR') }}</td>
                    <td>{{ line.voucherNumber || line.voucherId || '-' }}</td>
                    <td>{{ line.remittanceAdviceId || '-' }}</td>
                    <td>{{ line.exclusionReason || '-' }}</td>
                    <td><p-button label="Bill" icon="pi pi-external-link" size="small" [outlined]="true" (click)="openBill(line)" *ngIf="line.billId"></p-button></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="11">No lines available.</td></tr>
            </ng-template>
        </p-table>
    </ng-template>
</app-page-shell>
